import type { TCreatePessoaJuridicaData } from '@/features/proposta/services/criar-pessoa-juridica.service'
import { HttpService } from '@/infra/http'

export type TUpdatePessoaJuridicaData = TCreatePessoaJuridicaData & {
  id: string
}

export class AtualizarPessoaJuridica extends HttpService {
  execute = async ({ id, ...payload }: TUpdatePessoaJuridicaData) => {
    const response = await this.http.put<void>(`/api/v2/Conta/${id}`, payload)
    return response.data
  }
}
